export const menuItems = {
	demo: {
		main: {text: 'Home', link: '/'},
		sub: []},
	talentenspel: {
		main: {text: 'Talentenspel', link: '/talentenspel'},
		sub: []
	},
	coaching: {
		main: {text: 'Talentenspel Begeleiding', link: '/talentenspel-begeleiding'},
		sub: []},
	scholing: {
		main: {text: 'Scholing', link: '/scholing'},
		sub: [
		{text: 'Persoonlijke Supervisie', link: '/scholing/persoonlijke-supervisie'},
		{text: 'Module Communicatie / Counseling Topki', link: '/scholing/module-communicatie-counseling'},
		{text: 'Nascholing', link: '/scholing/nascholing'},
		{text: 'Scholing Talentenspel Coaches', link: '/scholing/scholing-talentenspel-coaches'}
		]},
	contact: {
		main: {text: 'Contact', link: '/contact'},
		sub: []}
};



// WEBPACK FOOTER //
// ./src/recourses/menu.js